import app from '../../main';
import { http } from '../../axios';
import {plainObjectsId} from '../../helpers/formsData';
import { downloadByLink } from '../../helpers/download';

function getInitState() {
  return {
    loading: {
      list: false,
      listMore: false,
    },
    list: [],
    filtersList: [],
    resumesFiltersList: [],
    nextPageUrl: null,
  };
}

function onRequestError(title, message) {
  return () => {
    app.$vModal.open('warning', { title, message });
  };
}

export default {
  namespaced: true,
  state: getInitState(),
  actions: {
    defineLoadUrls({ rootGetters }) {
      if (rootGetters['user/isEmployer']) return {
        list: '/api/cabinet/employer/my-responses',
        filters: '/api/cabinet/employer/my-responses/get-vacancy-filter',
        resumes: '/api/cabinet/employer/my-responses/get-resumes',
      };

      return {
        list: '/api/cabinet/partner/my-responses',
        filters: '/api/cabinet/partner/my-responses/get-vacancy-filter',
        resumes: '/api/cabinet/partner/my-responses/get-resumes',
      };
    },

    async load({ commit, dispatch }, params) {
      commit('setLoadingProperty', ['list', true]);

      const { list: url } = await dispatch('defineLoadUrls');
      const config = params ? { params: plainObjectsId(params) } : {};
      const { data } = await http.get(url, config)
        .catch(onRequestError('Failed to load vacancies responses list', 'Please check your internet connection or try gain later'));

      if (data?.data) {
        commit('setProperty', ['list', data.data]);
        commit('setProperty', ['nextPageUrl', data.next_page_url]);
      }

      commit('setLoadingProperty', ['list', false]);
    },
    async loadMore({ commit, state }) {
      if (!state.nextPageUrl) return;

      commit('setLoadingProperty', ['listMore', true]);

      const { data } = await http.get(state.nextPageUrl)
        .catch(onRequestError('Failed to load vacancies responses list', 'Please check your internet connection or try gain later'));

      if (data?.data) {
        commit('addToList', data.data);
        commit('setProperty', ['nextPageUrl', data.next_page_url]);
      }

      commit('setLoadingProperty', ['listMore', false]);
    },
    async loadFilters({ commit, dispatch }) {
      const { filters: url } = await dispatch('defineLoadUrls');
      const { data } = await http.get(url)
        .catch(onRequestError('Failed to load filters', 'Please check your internet connection'));
      commit('setProperty', ['filtersList', data.data]);
    },
    async getResponseResumes({ dispatch }, params) {
      const { resumes: url } = await dispatch('defineLoadUrls');
      const config = params ? { params: plainObjectsId(params) } : {};
      const response = await http.get(url, config)
        .catch(onRequestError('Failed to load vacancy responses list', 'Please check your internet connection'));
      return response?.data?.data;
    },
    async setResumeMark(_, { mark, resumeId }) {
      const { data } = await http.post('/api/cabinet/employer/my-responses/set-mark', {
        mark,
        sent_resume_id: resumeId,
      }).catch(onRequestError('Failed to update vacancy response mark'));

      return data?.data;
    },
    async openResumePhone(_, { sent_resume_id }) {
      const { data } = await http.post('/api/cabinet/employer/my-responses/open-phone', { sent_resume_id })
        .catch(onRequestError('Failed to open resume phone'));
      return data?.data;
    },
    async saveResponseNote(_, { note, sent_resume_id }) {
      const { data } = await http.post('/api/cabinet/employer/my-responses/set-note', { note, sent_resume_id })
        .catch(onRequestError('Failed to save note', 'Check your internet connection or contact our support service'));

      return data?.data;
    },
    async createResumeTag(_, { tag, sent_resume_id }) {
      const { name, color } = tag;
      const { data } = await http.post('/api/cabinet/employer/my-responses/add-tag', {
        name,
        color,
        sent_resume_id,
      })
        .catch(onRequestError('Failed to update tags', 'Please try again later or check your connection to network'));
      return data?.data;
    },
    async saveResumeTags(_, { tags, sent_resume_id }) {
      const { data } = await http.post('/api/cabinet/employer/my-responses/update-tags', { tags, sent_resume_id })
        .catch(onRequestError('Failed to update tags', 'Please try again later or check your connection to network'));
      return data?.data;
    },
    async inviteCandidateToJob(_, { vacancyId, resumeId }) {
      const response = await http.post('/api/new-interaction/create', {
        vacancy_id: vacancyId,
        resume_id: resumeId,
      }).catch(onRequestError('Your request is failed', 'Try to invite candidate later. Check your internet connection'));
      return response?.data?.data;
    },
    async confirmCandidateResume(_, params) {
      const { data } = http.post('/api/edit-resume/accept-resume', params);
      return data;
    },
    async exportData(_, params) {
      const { data } = await http.get('/api/cabinet/employer/my-responses/export', { params })
        .catch(onRequestError('Failed to download file', 'Відбулась помилка, спробуйте будь-ласка пізніше'));
      downloadByLink(data.path);

      return data;
    },
    async unsetResumeAsNew(_, { sent_resume_id }) {
      const { data } = await http.post('/api/cabinet/employer/my-responses/unset-new', { sent_resume_id })
        .catch(onRequestError('Failed to sync vacancy resume status with server'));

      return data?.data;
    },
    async getPhonesStats() {
      const { data } = await http.get('/api/cabinet/employer/subscribe/phone-stats');
      return data?.data;
    },
  },

  mutations: {
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return;
      state[key] = value
    },
    setLoadingProperty(state, [key, value]) {
      if (!state.loading.hasOwnProperty(key)) return;
      state.loading[key] = value
    },
    addToList(state, data) {
      state.list = state.list.concat(data);
    },
  },

  getters: {
    list(state) {
      return state.list;
    },
    filtersList(state) {
      return state.filtersList;
    },
    resumesFiltersList(state) {
      return state.resumesFiltersList;
    },
    loading(state) {
      return state.loading;
    },
  },
};
